<template>
  <div>
    <login v-if="!isLogin"></login>
    <el-container v-else>
            <el-header>
            <el-menu :default-active="activeMenu"   mode="horizontal" @select="selectMenu" >
              <!-- <el-image :src="'https://img2.233.com/wx/union/pc/center/logo233.jpg'" class="logo"></el-image> -->
              <img style="float:left;margin-top:5px" height="50px"  src="@/assets/logo.png">
              <div v-for="item in routeSide" :key="item.path" class="fordiv" >
                <template v-if="(item.path!='more'||manger.Id==1||manger.Id==8||manger.Id==16)" >
                  <el-menu-item  v-if="!item.children && item.meta.showInMenu && ifHas(item.code)&&
                (item.name!='daily'||manger.Id==1||manger.Id==45||manger.Id==62||manger.Id==8||manger.Id==16)" :index="item.path">
                      <el-badge v-if="(item.name=='topup'&&hasReview)||(item.name=='outsider'&&balanceWarning)" 
                      style="margin-top:-5px" :is-dot="true" >
                      </el-badge>
                      {{item.meta.navtitle}}
                  </el-menu-item>
                  <el-submenu v-if="item.children && item.meta.showInMenu && ifHas(item.code)" :index="item.path">
                    <template slot="title">{{item.meta.navtitle}}</template>
                    <template v-for="vel in item.children">
                      <el-menu-item  v-if="ifHas(vel.code)" :key="vel.path" :index="vel.path">{{ vel.meta.navtitle }}</el-menu-item>
                    </template>
                  </el-submenu>
                </template>

              </div>
              
              <el-tooltip class="item" effect="dark" content="退出登录" placement="left">
                  <el-button style="float:right;margin-top:15px;margin-right:20px" type="danger" @click="logout" size="mini" icon="el-icon-switch-button" circle></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="开启音效" placement="left">
                  <el-button style="float:right;margin-top:15px;margin-right:20px"  @click="play" size="mini" :icon="isPlay?'el-icon-microphone':'el-icon-turn-off-microphone'" circle></el-button>
              </el-tooltip>
              
              <el-link  icon="el-icon-user-solid" type="primary" style="margin-top:20px;float:right;margin-right:20px">{{manger.RealName}}</el-link>

              <el-switch
              @change="managerSetIsOnLine"
                style="float:right;margin-top:20px;margin-right:20px"
                v-model="isOnLine"
                active-text="在线"
                inactive-text="离线">
              </el-switch>
            </el-menu>
          </el-header>

          <el-main>
            <transition name="el-fade-in">
              <router-view :manger="manger" />
            </transition>
          </el-main>
    </el-container>
    <audio id="message" style="display:none" controls="controls">
        <source src="../assets/message.wav" />
    </audio>
  </div>
      
</template>
<script>
import login from '@/page/login'
import { managerGetIsOnline,managerSetIsOnLine,transactionHasReview} from '@/request.js'
//import Header from "./components/Header";
import { constantRoutes } from "@/router";
export default {
   name: "Layout",
   components: {
      login
   },
  data() {
    return {
      manger:{},
      isLogin:false,
      activeIndex: '6',
      isPlay:false,
      isOnLine:false,
      routeSide: [],
      activeMenu: '/',
      menuArr: [],
      hasReview:false,
      timer:{},
      balanceWarning:false,
    };
  },
  watch:{
  },
  created() {
    var token= localStorage.getItem("usertoken");
    
      if(token==undefined){
        this.isLogin=false;
      }else{
        this.isLogin=true;
        this.manger=JSON.parse(localStorage.getItem("manger"))
        this.menuArr = JSON.parse(this.manger.Power);
        console.log(this.menuArr)
    }
  },
  mounted() {
         let route = this.$route
     //this.activeMenu = route.path
     if(route.meta.showInMenu == false) {
       this.activeMenu = '/' + route.path.split('/')[1]
     } else {
       this.activeMenu = route.path
     }
     this.routeSide = constantRoutes[0].children
      transactionHasReview({},(res)=>{
               this.hasReview=res.Result.HasReview;
              this.balanceWarning=res.Result.BalanceWarning;
           })
    managerGetIsOnline({},(res)=>{
      this.isOnLine=res.Result;
    });
    // this.initWebSocket();
      this.timer= setInterval(() => {
           transactionHasReview({},(res)=>{
               this.hasReview=res.Result.HasReview;
              this.balanceWarning=res.Result.BalanceWarning;
           })
       }, 3000);
  },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
   methods:{
     selectMenu(index) {
       this.$router.push({path: index})
     },
     ifHas(code){
       if(this.menuArr.indexOf(code) === -1) {
         return false
       } else {
         return true
       }
     },
     managerSetIsOnLine(){
       console.log(this.isOnLine);
       managerSetIsOnLine({isOnLine:this.isOnLine},()=>{

       });
     },
     play(){
       document.getElementById('message').play();
       this.isPlay=true;
     },
      initWebSocket(){ //初始化weosocket
        const wsuri = "wss://manage.hlqrolex.com/ws";
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen(){ //连接建立之后执行send方法发送数据
        this.websocketsend(JSON.stringify(this.manger));
      },
      websocketonerror(){//连接建立失败重连
        this.initWebSocket();
      },
      websocketonmessage(e){ //数据接收
        this.newMessage("新消息",e.data);
      },
      websocketsend(data){//数据发送
        this.websock.send(data);
      },
      websocketclose(e){  //关闭
        console.log('断开连接',e);
      },
     logout(){
        localStorage.removeItem("usertoken");
        this.isLogin=false;
     },
      newMessage(title,text){
        document.getElementById('message').play();
        if (window.Notification && Notification.permission !== "denied") {
            Notification.requestPermission(function () {
                var n = new Notification(title, {
                    body: text, icon: ''
                });
                n.onclick = function () {
                    n.close();
                };
            });
        }
      },
   }

}
</script>

<style >
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #fff;
}
::-webkit-scrollbar-thumb {
    border-radius:5px;
    background-color: #909399;
}
.el-menu .fordiv{display:inline-block}
.el-submenu__title i {
    display: contents
}
</style>